import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";

import LoadingComponent from "../components/LoadingComponent";

import { consumePostLoginRedirect, getActiveAccount, handleRedirectPromise } from "./msalInstance";
import { useAuth } from "./AuthProvider";

const MsalRedirectHandler = () => {
  const history = useHistory();
  const { isInitialized } = useAuth();

  useEffect(() => {
    if (!isInitialized) return;

    let isMounted = true;

    const resolveRedirect = async () => {
      try {
        await handleRedirectPromise();
      } catch (error) {
        // eslint-disable-next-line no-console
        console.warn("[auth] redirect handling failed", error);
      }

      if (!isMounted) return;

      const account = getActiveAccount();
      const redirectPath = account ? consumePostLoginRedirect() || "/" : "/";

      // eslint-disable-next-line no-console
      console.log("[auth] redirecting after callback", {
        hasAccount: Boolean(account),
        redirectPath,
      });

      history.replace(redirectPath);
    };

    resolveRedirect();

    return () => {
      isMounted = false;
    };
  }, [history, isInitialized]);

  return <LoadingComponent loading />;
};

export default MsalRedirectHandler;
